import { formatCurrencyValue } from '@vend/utilities'
import React from 'react'
import {
  useRegisterManager,
  useRetailerSettingsManager,
} from '../../../ng-compat/hooks'

interface Props {
  subtotal: number | string
}

export const Subtotal: React.FC<Props> = ({ subtotal }) => {
  const currentOutlet = useRegisterManager().getActiveOutlet()
  const retailer = useRetailerSettingsManager().get()

  return (
    <>
      <div>Subtotal</div>
      <div className="sale-total-line-item--value">
        {formatCurrencyValue(
          subtotal,
          retailer.culture,
          currentOutlet.currency,
          currentOutlet.currency_symbol
        )}
      </div>
    </>
  )
}
